import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { SegmentationBuilderComponent } from './segmentation-builder/segmentation-builder.component';
import { SegmentationMembersComponent } from './segmentation-members/segmentation-members.component';
import { GridComponent } from './segmentation-members/grid/grid.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
const routes: Routes = [
  {
    path: 'segmentation-builder', 
    component: SegmentationBuilderComponent,
     runGuardsAndResolvers: 'always'},
  {
  path: 'segmentation-members', 
  component: SegmentationMembersComponent,
  children: [
    {
      path: "grid", component:GridComponent}],
    },
    {
      path: '**',
      component: PageNotFoundComponent,
      runGuardsAndResolvers: 'always',
      pathMatch: 'full',
      },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload', // needed so if the user refreshes the page we reload the whole app. it's an easier app state handling.
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}